// Origin
import { OriginSize } from "shared/origin";
import { Cull } from '@pixi-essentials/cull';

// Interfaces
import { IScreen } from "shared/interfaces";
// Screens
import { Game } from "screens";
import { MapScreen } from "./map/map";
// Services
import { LoaderService, ResizeService, PopupsService } from "shared/services";
// Helpers
import { GetUrlParamsHelper, PreloaderHelper } from "shared/helpers";
// Config
import { LevelsConfig, MapConfig } from "shared/config";
// Storages
import { GameViewStorage } from "shared/storages";

export class Main {
    private static _instance: Main = null;

    static get instance(): Main {
        if (Main._instance === null) {
            Main._instance = new Main();
        }
        return Main._instance;
    }

    public app: PIXI.Application;
    public htmlContainer: HTMLElement;
    public currectScreen: IScreen;
    public map: MapScreen;
    public resizeService: ResizeService;
    private loaderService: LoaderService;
    private mainLoader;
    private mainAssetsStatus: boolean = false;
    private gameAssetsLoad: boolean = false;
    public popups;
    private currentLevel = {
        num: 1,
        type: 'background_release'
    };

    public showTotorial(tutorial): void {

    }

    public initMap(): void {        
        this.openMap();
    }

    public initApp = (): void => {
        const main = document.getElementById('main');
        const cull = new Cull({ recursive: true, toggle: 'renderable' });
        main.style.display = 'none';
        this.htmlContainer = document.getElementById('app');
        this.htmlContainer.style.display = 'flex';
        this.resizeService = new ResizeService();
        this.app = new PIXI.Application({
            width: OriginSize.width,
            height: OriginSize.height,
            // width: window.innerWidth * window.devicePixelRatio,
            // height: window.innerHeight * window.devicePixelRatio,
            transparent: true,
        });
        cull.add(this.app.stage);
        this.htmlContainer.appendChild(this.app.view);
        window.addEventListener('resize', () => {
            this.resizeService.resizeScene(this.app);
        })
        this.map = new MapScreen();
        this.checkUrl();

        this.resizeService.resizeScene(this.app);
        this.app.renderer.on('prerender', () => {
            // Cull out all objects that don't intersect with the screen
            cull.cull(this.app.renderer.screen);
        });
        // 7744
    };

    private checkUrl(): void {
        // const params = GetUrlParamsHelper.getParams(window.location.href);

        // if (params.level && LevelsConfig.levels[params.level]) {
        //     this.currentLevel = {
        //         num: params.level,
        //         type: LevelsConfig.levels[params.level].type
        //     }
        // }
        
        this.openMap();
    }

    // private checkUser(): void {
    //     const user = JSON.parse(localStorage.getItem('mbny_game_user'));

    //     if (!user) {
    //         document.getElementById('login_btn').addEventListener('click', () => {
    //             this.loadGame();
    //         })
    //     }
    // }

    public loadGame(): void {
        const user = JSON.parse(localStorage.getItem('mbny_game_user'));
        PreloaderHelper.togglePreloader(false);

        if (user && user.tutorails.background_release) {
            this.openMap();
        } else {
            document.getElementById('background_release_tutroial').style.display = 'flex';
            this.addTutorialListeners();
        }

        // this.currectScreen = new Menu();
        // this.currectScreen.init();
        // this.currectScreen.show();

        // this.loaderService = new LoaderService();
        // this.resizeService = new ResizeService();

    }

    private addTutorialListeners(): void {        
        document.getElementById('startLevel').addEventListener('click', () => {
            const user = JSON.parse(localStorage.getItem('mbny_game_user'));
            user.tutorails.fillBar = true;
            localStorage.setItem('mbny_game_user', JSON.stringify(user))
            document.getElementById('background_release_tutroial').style.display = 'none';

            this.openMap();
        })

        document.getElementById('closeTotorial').addEventListener('click', () => {
            const user = JSON.parse(localStorage.getItem('mbny_game_user'));
            user.tutorails.fillBar = true;
            localStorage.setItem('mbny_game_user', JSON.stringify(user))
            document.getElementById('background_release_tutroial').style.display = 'none';

            this.openMap();
        })
    }

    public showGameScreen(): void {
        const main = document.getElementById('main');
        main.style.display = 'none';
        this.htmlContainer = document.getElementById('app');
        this.htmlContainer.style.display = 'flex';
        this.currectScreen.show();
    }

    public openMap(): void {
        // this._checkIsShowRevards();
        PreloaderHelper.togglePreloader(false);
        
        this.map.init(this.currentLevel);
    }

    public startGame(level): void {
        const btn = document.getElementById('mapBtn');
        btn.style.display = 'none';

        this.currectScreen = Game.instance;
        this.currectScreen.init(level);
        this.currectScreen.show();
        const isGameLoad = GameViewStorage.isViewLoad;
        
        // if (isGameLoad) {            
        //     this.currectScreen.show();
        // } else {            
        //     this.currectScreen = Game.instance;
        //     this.currectScreen.init(level);
        //     this.currectScreen.show();
        // }

        const menu = document.getElementById('mapMenu');
        menu.style.display = 'none';
    }
}